


































































































































































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { User, Toast } from "../types";
import { APopoverTarget } from "@canvas/componentlibrary";
export default Vue.extend({
  components: {
    APopoverTarget
  },
  data: () => ({
    dropdownSelected: {
      name: "",
      display_name: ""
    },
    screenX: null as null | MediaQueryList,
    isSidebarEnabled: false,
    // isOnMobileDevice: false,
    isSubmenuVisibleBool: false,
    arrowIcon: "RightArrow",
    title: "Canvas Swatch Management",
    sidebarItems: [
      {
        text: "Manage Inventory",
        icon: "Reports",
        // active: true,
        route: "/inventory",
        activeRoutes: [
          "inventory",
          "products",
          "skus",
          "samples",
          "addinventory",
          "skuslist",
          "addfinish",
          "editfinish"
        ]
      },
      {
        text: "Transaction History",
        icon: "Time",
        // active: false,
        route: "/trxnhistory",
        activeRoutes: ["trxnhistory", "trxnhistorysearch"]
      }
    ],
    userSubMenuItems: [
      // {
      //   text: "My Profile",
      //   route: "/profile"
      // },
      {
        text: "Logout",
        route: "/logout"
      }
    ]
  }),
  mounted() {
    this.screenX = window.matchMedia("(max-width: 480px)");
    this.toggleMobileView(this.screenX);
    this.screenX.addListener(this.toggleMobileView);
    //if no ecid is url then redirect to inventory page with selected ec
    if (!this.$router.currentRoute.params.ecId) {
      this.$router.push({ path: "/" + this.selectedEc.name + "/inventory" });
    } else {
      //select and store the ecid in url
      this.$store.dispatch(
        "appModule/selectUserEc",
        this.$router.currentRoute.params.ecId
      );
    }
  },
  props: {},
  computed: {
    ...mapState("appModule", {
      // isOnMobileDevice: "isOnMobileDevice",
      user: "loggedInUser",
      ecList: "ecList",
      selectedEc: "selectedEc"
    }),
    ...mapState("uiModule", {
      isOnMobileDevice: "isOnMobileDevice",
      modalElement: "modalElement",
      toasterItems: "toastsList"
      // user: "loggedInUser"
    })
  },
  methods: {
    ...mapActions("uiModule", ["toggleMobileDeviceState"]),
    onSidebarLinkClicked(link: any) {
      this.$router.push({ path: "/" + this.selectedEc.name + link.route });
    },
    handleToasterClose(eventData: Toast) {
      this.$store.commit("uiModule/clearToast", eventData);
    },
    isActiveRoute(activeRoutes: string[], routeName: string) {
      // for (var i = 0; i < activeRoutes.length; i++) {
      //   if (activeRoutes.includes(route)) {
      //     return true;
      //   }
      // }
      if (activeRoutes.includes(routeName)) {
        return true;
      }
      return false;
    },
    toggleMobileView(screenX: any) {
      if (screenX.matches) {
        this.toggleMobileDeviceState(true);
        // this.isOnMobileDevice = true;
        if (this.isSubmenuVisibleBool) {
          this.arrowIcon = "DownArrow";
        } else {
          this.arrowIcon = "UpArrow";
        }
      } else {
        this.arrowIcon = "RightArrow";
        this.isSidebarEnabled = true;
        this.toggleMobileDeviceState(false);
        // this.isOnMobileDevice = false;
      }
    },
    toggleSubmenu(boolValue: boolean) {
      this.isSubmenuVisibleBool = boolValue;
      this.toggleMobileView(this.screenX);
    },
    toggleSidebar(toggleValue: boolean) {
      if (this.isOnMobileDevice) {
        this.isSidebarEnabled = toggleValue;
      }
    },
    onDropdownOptionSelected(selected: { name: string; display_name: string }) {
      this.$store.commit("appModule/setSelectedEc", selected);
      this.$store.dispatch("trackSegementEvents", {
        eventName: "CMS_SEARCH",
        properties: { query: selected }
      });
      this.$router.push({ path: "/" + this.selectedEc.name + "/inventory" });
    }
  }
});
